import clsx from 'clsx';
import { AmountUtils, ColorUtils, DateUtils, splitCamelCase } from '@shared/utils';
import type { TransferRequestResponse } from '@shared/api/rest/transferRequests';
import { Table, TableCellType } from '@shared/widgets';

interface ITableProps {
  color?: 'paper';
  data: TransferRequestResponse[];
  isLoading?: boolean;
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
  setSelectedTransfer: (data: TransferRequestResponse) => void;
}

export const TransferTable = (props: ITableProps) => {
  return (
    <Table
      columns={['Status', 'Date', 'Description', 'Transaction Type', 'From', 'To', 'Amount', 'Fee']}
      items={props.data?.map((row) => {
        const color = ColorUtils.getTransferRequestStatusStyles(row.status);
        return [
          {
            type: TableCellType.Custom,
            value: <div className={clsx('py-1 px-2 text-center font-normal text-nowrap', color.bg, color.text)}>{color.label}</div>,
          },
          {
            type: TableCellType.Text,
            value: DateUtils.formatDate(row.createdOn || ''),
          },
          { type: TableCellType.Text, value: row.reasonOfThePayment },
          {
            type: TableCellType.Text,
            value: splitCamelCase(row.type),
          },
          {
            type: TableCellType.Text,
            value: row.fromAccount.name,
          },
          {
            type: TableCellType.Text,
            value: row.beneficiaryAccount?.name || row?.recipient?.name || '-',
          },
          {
            type: TableCellType.Text,
            value: AmountUtils.transformToAmountWithCurrency(row.senderAmount, row.senderCurrency),
          },
          {
            type: TableCellType.Text,
            value: AmountUtils.transformToAmountWithCurrency(row.fee, row.senderCurrency),
          },
        ];
      })}
      onClick={(rowIndex) => props.setSelectedTransfer(props.data[rowIndex])}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
      isScrollable
      isLoading={props.isLoading}
    />
  );
};
